import { render } from "./2022-11-12-Parent Child Contact.md?vue&type=template&id=721a3aca"
const script = {}
script.render = render

export default script